import useInstanceCallback from "./useInstanceCallback.js";
import { fireValueChange } from "./Util.js";
const onValueChange = (props, evt) => {
  fireValueChange(props.modelClass, props, evt);
};
const createValueChange = modelClass => {
  function fire(evt) {
    fireValueChange(modelClass, this.props, evt);
  }
  return fire;
};

/**
 * Will return an instance callback that will invoke
 * props.modelClass[evt.data]( props.value, evt.value ) and
 * send the result to props.onChange( { value, data : props.data )
 */
export default function useValueChange(modelClass, props) {
  const {
    value,
    onChange,
    eventData
  } = props;
  return useInstanceCallback(onValueChange, {
    modelClass,
    value,
    onChange,
    eventData
  });
}
export { onValueChange, createValueChange };